import ouiBase from '@goldwasserexchange/oui';
import { useGetFieldPath } from '../../../../../../context/fieldPath';

export const useRadioHtmlId = () => {
  const fieldPath = useGetFieldPath();
  const primaryKey = ouiBase.utils.dimensions.useCurrentPrimaryDimensionValueByIndex();
  const htmlId = `${fieldPath}-${primaryKey}`;
  return htmlId;
};
